import { render, staticRenderFns } from "./BoxEntriesHeaderName.vue?vue&type=template&id=5f0743cb&"
import script from "./BoxEntriesHeaderName.vue?vue&type=script&lang=ts&"
export * from "./BoxEntriesHeaderName.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports